export default "__VITE_ASSET__Dmg8HPyY__"